import { useRouter } from 'next/router'

const useIsRay = () => {
  const { asPath } = useRouter()
  return !!asPath.match('/ray') || !!asPath.match('/auth')
}

export default useIsRay
